import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CycleTimeKPI } from '@App/models';
import { SharedModule } from '@Shared/shared.module';

@Component({
  selector: 'app-key-performance-indicators',
  templateUrl: './key-performance-indicators.component.html',
  styleUrl: './key-performance-indicators.component.scss',
  imports: [SharedModule]
})
export class KeyPerformanceIndicators implements OnChanges {
  @Input() kpiData: CycleTimeKPI[] = [];
  @Input() currentAssignedCases: number = 0;
  totalAverageCycleTime: number = 0;
  totalPreviousAverageCycleTime: number = 0;

  cycleTimeDays: number = 0;
  cycleTimeHours: number = 0

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['kpiData'] && this.kpiData) {
      if (this.kpiData.length === 0) {
        this.totalAverageCycleTime = 0;
        this.totalPreviousAverageCycleTime = 0;
        this.cycleTimeDays = 0;
        this.cycleTimeHours = 0;
        return;
      }
      this.totalAverageCycleTime = this.kpiData.reduce((sum, kpi) => sum + (kpi.averageCaseCycleTime || 0), 0) / this.kpiData.length;
      this.totalPreviousAverageCycleTime = this.kpiData.reduce((sum, kpi) => sum + (kpi.previousAverageCaseCycleTime || 0), 0) / this.kpiData.length;

      this.cycleTimeDays = Math.floor(this.totalAverageCycleTime / 24);
      this.cycleTimeHours = Math.floor(this.totalAverageCycleTime % 24);
    }
  }

}
